import React from "react";
import { useLang } from "../../context/LanguageContext";

/**
 * Tre steg med vad de kostar.
 *
 * Designen sätter en tidsstämpel på varje steg: "Idag", "Inom 48 timmar",
 * "Inom 30 dagar". Den andra är struken. **Vi kan inte lova när en talang
 * svarar**, eftersom det är en fri yrkesutövare som bestämmer själv, och ett
 * löfte vi inte kontrollerar blir ett löfte vi bryter. Det som står i stället är
 * sant och lika lugnande: förfrågan går ut direkt, och högst fem kan svara.
 *
 * Prislappen per steg är den viktigaste raden i hela sektionen. Kunden har
 * precis mött en marknadsplats och undrar var haken sitter. Att skriva 0 kr två
 * gånger i rad besvarar frågan innan den ställs.
 */

const T = {
  sv: {
    eyebrow: "Så fungerar det",
    heading: "Från förfrågan till bokat,\nutan att jaga någon.",
    steps: [
      { when: "Tar två minuter", title: "Beskriv eventet",
        body: "Datum, plats, gäster, stil och budget. Förfrågan går ut till talangerna i din kategori och stad direkt.",
        cost: "Kostnad: 0 kr" },
      { when: "Högst fem svar", title: "Få offerter med pris",
        body: "Talangerna som är intresserade skickar en offert med pris, vad som ingår och en personlig hälsning. Fler än fem kan aldrig svara, så inkorgen fylls inte.",
        cost: "Kostnad: 0 kr" },
      { when: "När du valt", title: "Boka och betala tryggt",
        body: "Signera avtalet och betala med kort eller faktura. Talangen får sina pengar först efter att eventet är genomfört.",
        cost: "Kostnad: talangens pris" },
    ],
  },
  en: {
    eyebrow: "How it works",
    heading: "From request to booked,\nwithout chasing anyone.",
    steps: [
      { when: "Takes two minutes", title: "Describe the event",
        body: "Date, place, guests, style and budget. Your request goes out to talents in your category and city right away.",
        cost: "Cost: 0 kr" },
      { when: "At most five replies", title: "Get priced offers",
        body: "Interested talents send an offer with a price, what is included, and a personal note. No more than five can ever reply, so your inbox stays manageable.",
        cost: "Cost: 0 kr" },
      { when: "When you have chosen", title: "Book and pay safely",
        body: "Sign the agreement and pay by card or invoice. The talent is paid only after the event has taken place.",
        cost: "Cost: the talent's price" },
    ],
  },
};

const HowItWorks3 = () => {
  const { lang } = useLang();
  const t = T[lang === "sv" ? "sv" : "en"];
  return (
    <section className="border-t border-[#1e1e1e]" data-testid="how-it-works-3">
      <div className="max-w-[1100px] mx-auto px-6 py-20 md:py-24">
        <div className="text-center mb-14">
          <div className="text-[11px] uppercase tracking-[0.2em] text-neutral-500 mb-3">{t.eyebrow}</div>
          <h2 className="text-[36px] md:text-[48px] font-extrabold tracking-tight text-white leading-[1.08] whitespace-pre-line">
            {t.heading}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {t.steps.map((s, i) => (
            <div key={s.title} data-testid={`hiw-step-${i + 1}`}
              className={`rounded-2xl border bg-[#181818] p-7 transition-colors ${
                i === 1 ? "border-[#FF5C00]/35" : "border-[#2A2A2A] hover:border-[#3A3A3A]"}`}>
              <div className="flex items-center gap-3 mb-5">
                <span className="w-9 h-9 rounded-full bg-[#FF5C00] text-white font-bold text-[15px] flex items-center justify-center shrink-0">
                  {i + 1}
                </span>
                <span className="text-[11.5px] uppercase tracking-wider text-[#FF7A2F] font-semibold">{s.when}</span>
              </div>
              <h3 className="text-[21px] font-bold text-white mb-2.5">{s.title}</h3>
              <p className="text-[14px] text-neutral-400 leading-relaxed mb-5">{s.body}</p>
              <div className="text-[12.5px] text-neutral-500 pt-4 border-t border-[#2A2A2A]">{s.cost}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks3;
